import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fireUserAction } from '../actions/actions-entrypoint';

let INSTANCE = null; // instance of this class

class UserActionsHandler extends Component {
  componentDidMount() {
    INSTANCE = this;
  }

  componentWillUnmount() {
    INSTANCE = null;
  }

  userActionFired(action) {
    const { onFireAction } = this.props;
    onFireAction(action);
  }

  static userActionFired(action) {
    if (INSTANCE) {
      INSTANCE.userActionFired(action);
    }
  }

  render() {
    return <div />; // no-op
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFireAction: (action) => {
      dispatch(fireUserAction(action));
    },
  };
};

export default connect(null, mapDispatchToProps)(UserActionsHandler);
